import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import "./FaqSection.css";

// ---------------------------------------------------------------------------
// Данные вопросов и ответов (исправленные тексты)
// ---------------------------------------------------------------------------
const FAQ_ITEMS = [
  {
    question: "Вы работаете только в Екатеринбурге?",
    answer:
      "Нет, базируемся в Екатеринбурге и выполняем проекты по всему УрФО: Свердловская, Челябинская, Курганская, Тюменская области, Пермский край, ХМАО и ЯНАО. Формат выезда и сопровождения обсуждаем под конкретный объект.",
  },
  {
    question: "Какие сети связи и слаботочные системы вы строите?",
    answer:
      "Основная экспертиза — СКС, ВОЛС, СОТ, СКУД, Wi-Fi, серверные, телекоммуникационные шкафы и узлы связи, а также настройка активного сетевого оборудования и интеграция систем в инфраструктуру заказчика.",
  },
  {
    question: "У вас есть СРО для проектирования и строительства?",
    answer:
      "Да, ООО «АЙТИ СИСТЕМЫ» имеет проектное и строительное СРО. Выполняем полный цикл работ — от обследования и проектной документации до строительно-монтажных и пусконаладочных работ.",
  },
  {
    question: "Можно разбить проект на этапы?",
    answer:
      "Да. Например: сначала строим магистрали, СКС и серверную, затем подключаем СОТ, СКУД, Wi-Fi и активное оборудование. График согласуем с бюджетом, производственным циклом и доступностью помещений.",
  },
  {
    question: "Работаете на действующих объектах?",
    answer:
      "Да, работаем на действующих офисных, промышленных и складских объектах. Планируем монтаж по зонам, выполняем работы в нерабочее время и заранее согласовываем окна, чтобы не останавливать процессы заказчика.",
  },
  {
    question: "Вы делаете только монтаж или полный цикл работ?",
    answer:
      "Выполняем полный цикл: обследование, проектирование, поставка оборудования, строительство сетей связи, монтаж СКС/СОТ/СКУД, настройка серверного и сетевого оборудования, пусконаладка и сервис. Также работаем по готовой документации заказчика.",
  },
  {
    question: "На каких объектах вы работаете?",
    answer:
      "Работаем с промышленными предприятиями, бизнес-центрами, офисами, торговыми центрами, складскими и логистическими комплексами, производственными площадками и режимными объектами.",
  },
  {
    question: "Сколько времени занимает реализация проекта?",
    answer:
      "Срок зависит от объёма и доступа на объект. Небольшая офисная сеть — от 2–3 недель. Крупная промышленная площадка или комплекс СОТ/СКУД/СКС — от нескольких месяцев. Точную оценку даём после обследования.",
  },
  {
    question: "Какие гарантии и сервисное обслуживание вы предоставляете?",
    answer:
      "Даём гарантию на выполненные работы и сохраняем заводскую гарантию на оборудование. После сдачи заключаем сервисный контракт: профилактика, удалённая диагностика и аварийные выезды.",
  },
  {
    question: "Вы работаете с тендерами и госзаказами?",
    answer:
      "Да, участвуем в коммерческих тендерах и госзакупках. Есть СРО, полный пакет юридических и банковских реквизитов, опыт подготовки технических решений, смет, исполнительной документации и закрывающих документов.",
  },
];

// ---------------------------------------------------------------------------
// Компонент
// ---------------------------------------------------------------------------
export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(null);

  const toggle = (idx) => setOpenIdx(openIdx === idx ? null : idx);

  return (
    <section id="faq" className="faq-section">
      <div className="faq-container">
        <div className="faq-layout">

          {/* ── Левая колонка: заголовок ── */}
          <div className="faq-heading-col">
            <div className="faq-heading-sticky">
              <div className="faq-eyebrow">Ответы на вопросы</div>
              <h2 className="faq-title">Часто задаваемые вопросы</h2>
            </div>
          </div>

          {/* ── Правая колонка: аккордеон ── */}
          <div className="faq-list-col">
            <div className="faq-list">
              {FAQ_ITEMS.map((item, idx) => {
                const isOpen = openIdx === idx;
                return (
                  <div key={idx} className="faq-item">

                    {/* Кнопка-вопрос */}
                    <button
                      className="faq-item__btn"
                      onClick={() => toggle(idx)}
                      aria-expanded={isOpen}
                    >
                      <span className={`faq-item__question${isOpen ? " faq-item__question--open" : ""}`}>
                        {item.question}
                      </span>
                      <div className={`faq-item__icon${isOpen ? " faq-item__icon--open" : ""}`}>
                        {isOpen
                          ? <Minus width={16} height={16} />
                          : <Plus  width={16} height={16} />
                        }
                      </div>
                    </button>

                    {/* Раскрывающийся ответ */}
                    <div className={`faq-item__answer${isOpen ? " faq-item__answer--open" : ""}`}>
                      <p className="faq-item__text">{item.answer}</p>
                    </div>

                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}